import { Drawer } from "antd";
import styles from "./styles.module.scss";
import PermissionsList from "components/cards/PermissionsList";
import TextInput from "components/inputs/TextInput";
import Button from "components/general/Button";
import { IoMdClose } from "react-icons/io";
import Text from "components/general/Text";
import { useState } from "react";
import { useCreateRoleMutation } from "apis/services/permissions";
import showSuccessMsg from "utils/showSuccessMsg";
import HandleErrors from "utils/handleErrors";

export default function AddRoleDrawer({
    containerStyle,
    isVisible,
    setIsVisible,
}: {
    containerStyle?: string;
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}) {
    const [createRole, { isLoading: isCreatingRole }] = useCreateRoleMutation();
    const [roleName, setRoleName] = useState<string>("");
    // const [roleDescription, setRoleDescription] = useState("");
    const [permissions, setPermissions] = useState<number[]>([]);

    const handleCreateRole = () => {
        const values = {
            name: roleName,
            permissions: permissions,
        };
        createRole(values)
            .unwrap()
            .then(() => {
                setIsVisible(false);
                showSuccessMsg({ msg: "Role created successfully" });
            })
            .catch(HandleErrors);
    };
    return (
        <Drawer
            title={
                <div className={styles.drawerHeader}>
                    <Text className={styles.title}>Create New Role</Text>
                    <Text className={styles.subtitle}>
                        Configure role name and system action permissions
                    </Text>
                </div>
            }
            headerStyle={{ borderBottom: "1px #D9D9D9 solid", paddingBlock: "24px" }}
            placement="right"
            onClose={() => setIsVisible(false)}
            open={isVisible}
            closeIcon={false}
            extra={
                <div onClick={() => setIsVisible(false)} className={styles.closeIcon}>
                    <IoMdClose size={28} color="dark" />
                </div>
            }
            width={"40%"}
            className={`${styles.drawer} ${containerStyle}`}
        >
            <div className={styles.drawerContent}>
                <div className={styles.inputsContainer}>
                    <TextInput
                        label="Role Name"
                        placeholder="Enter role name"
                        value={roleName}
                        onChange={(e) => setRoleName(e.target.value)}
                    />
                    {/* <TextInput label="Role Description" placeholder="Enter role description" type="textarea" /> */}
                </div>
                <PermissionsList
                    showSaveButton={false}
                    onChange={(values) => setPermissions(values)}
                />
            </div>

            <div className={styles.footer}>
                <Button
                    btnClassName={styles.cancelBtn}
                    isOutline
                    onClick={() => setIsVisible(false)}
                >
                    Cancel
                </Button>
                <Button
                    btnClassName={styles.saveBtn}
                    onClick={handleCreateRole}
                    isLoading={!!isCreatingRole}
                    disabled={!roleName}
                >
                    Create Role
                </Button>
            </div>
        </Drawer>
    );
}
